export default function CommentRenderer({ comment }) {
  // แปลง mention เป็น HTML
  const formattedComment = comment.replace(
    /@\[(.*?)\]\((\d+)\)/g,
    (_, name, id) => {
      return `<span class="mention" data-id="${id}" style="color:#0078d4 ; font-weight:400;">@${name}</span>`;
    }
  );

  return (
    <div
      dangerouslySetInnerHTML={{ __html: formattedComment }}
      style={{
        lineHeight: "1.5rem",
        whiteSpace: "pre-wrap",   // ✅ แสดงบรรทัดใหม่ตาม \n
        wordBreak: "break-word",  // ✅ ตัดคำยาว
      }}
    />
  );
}
